// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"164ec3db","787":"51cd4e20"}[chunkId] + ".chunk.js";
};